export type ExportStage = 'collecting' | 'preparing' | 'building' | 'retrying' | 'downloading';
export type ExportProgress = { stage: ExportStage; cardCount?: number };
export type ReportExportProgress = (progress: ExportProgress) => void;

export const exportStageCopy: Record<ExportStage, string> = {
  collecting: 'Collecting your kept cards…',
  preparing: 'Preparing your export…',
  building: 'Building your Anki file… Large decks and images can take a little longer.',
  retrying: 'The export is taking longer than expected. Retrying automatically…',
  downloading: 'Receiving your file and starting the download…',
};

export function warnBeforeExportUnload(event: BeforeUnloadEvent) {
  event.preventDefault();
  event.returnValue = '';
}
